<template>
  <div class="line-item bfcm-gift">
    <div class="line-item__left">
      <a class="line-item__link" data-click-id="cart_thumbnail_clicks">
        <img class="line-item__image" :src="freeGift?.image" :alt="freeGift?.title"
          data-click-id="cart_thumbnail_clicks" />
      </a>
    </div>
    <div class="line-item__right">
      <div class="line-item__details">
        <div>
          <h4 v-html="`<span class='free-tag'>FREE </span>` + freeGift.title" class="line-item__heading" />
          <div class="line-item__info">
            <span v-if="props.added">
              Free Go Bars if you place your order in the next
            </span>
            <span v-else>
              Free Go Bars if you add to cart in next
            </span>
            <span class="bfcm-countdown"></span>
          </div>
        </div>


        <div class="line-item__price">
          <span class="sale">FREE</span>
          <span class="compare" v-text="getFormattedPrice(freeGift?.price, currencySymbol)"></span>
          <button v-if="props.itemsSubtotalPrice > 9900" @click="addGiftToCart()" class="line-item__add">
            Add <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M7.33398 8.66683H3.33398V7.3335H7.33398V3.3335H8.66732V7.3335H12.6673V8.66683H8.66732V12.6668H7.33398V8.66683Z"
                fill="white" />
            </svg>
          </button>
          <div v-if="props.added" class="line-item__added">
            Added <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path
                d="M4.77578 8.9998L1.92578 6.1498L2.63828 5.4373L4.77578 7.5748L9.36328 2.9873L10.0758 3.6998L4.77578 8.9998Z"
                fill="black" />
            </svg>
          </div>
          <!--
            <button @click="removeGift()" v-if="props.added" class="line-item__remove">
              Remove
            </button>
             -->
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref } from 'vue';
import cartMethods from '../../../bundles/utils/helpers/cart-helper';
import { EVENTS } from '../cart/constants'
import { getFormattedPrice } from './helpers';

const freeGift = ref(window.theme?.bfcm?.freeGift);
const currencySymbol = window.BPN?.cart?.currencySymbol;

const props = defineProps({
  itemsSubtotalPrice: {
    type: Number,
    default: () => 0,
  },
  added: {
    type: Boolean,
    default: () => false,
  },
  itemId: {
    type: String,
    default: () => '',
  },
});

const addGiftToCart = async () => {
  await cartMethods.post('add', {
    id: freeGift.value.variantId,
    quantity: 1,
    properties: { _isFreeGift: true }
  })
  document.dispatchEvent(new CustomEvent(EVENTS.ITEM_ADDED, {
    detail: { id: freeGift.value.variantId },
  }));
}

const removeGift = async () => {
  await cartMethods.post('change', {
    id: props.itemId,
    quantity: 0,
  })
  document.dispatchEvent(new CustomEvent(EVENTS.ITEM_ADDED))
  // document.dispatchEvent(new CustomEvent(EVENTS.UPDATED, {
  //   detail: { id: props.itemId },
  // }));
}
</script>
